import React, { ReactNode } from 'react';
import { TabPanel, TabView, TabViewProps } from 'primereact/tabview';

export type TabsViewProps = TabViewProps & {
  children: ReactNode;
};

export const TabsView = (props: TabsViewProps): JSX.Element => {
  // we need to map children since TabsView only accepts TabPanel
  const children = React.Children.map(props.children, child => {
    if (React.isValidElement(child)) {
      return <TabPanel {...child.props}>{child.props.children}</TabPanel>;
    }
    return child;
  });
  return <TabView {...props}>{children}</TabView>;
};
